var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info } from 'shared/assets/icons';
import { Box, Flex, Text, Icon, Tooltip } from 'shared/components';
export var UnknownProviderName = function (_a) {
    var isKareo = _a.isKareo;
    var tooltipLabel = isKareo
        ? "This note has been imported from Kareo, but we are not able to match this record to an author"
        : 'We are not able to match this record to an author';
    return (_jsxs(Box, { children: [_jsxs(Flex, __assign({ mb: 2, align: "center" }, { children: [_jsx(Tooltip, __assign({ label: tooltipLabel, hasArrow: true, placement: "top", maxW: "3xs" }, { children: _jsx(Box, { children: _jsx(Icon, { as: Info, boxSize: 4, color: "gray.500" }) }) })), _jsx(Text, __assign({ ml: 2 }, { children: "Unknown" }))] })), _jsx(Text, __assign({ size: "small" }, { children: "Unidentified author" }))] }));
};
